import { isMiniFeatureEnabled } from 'owa-mini-feature-flags';

export const isGroupByEmailsFeatureEnabled = () => {
    return isMiniFeatureEnabled('mini-group-emails-by-age');
};
